import ProductTable from './ProductTable'

const ProductTab = () => {
  return <ProductTable />
}

export default ProductTab
